<template>
  <div>
    <input type="time" class="modal-select" :value="time" @change="onChange($event.target.value)"/>
  </div>
</template>

<script>
import moment from 'moment-timezone'
moment.tz.setDefault('Asia/Tokyo')

export default {
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      default: ""
    }
  },
  mounted () {
    this.default = this.time
  },
  methods: {
    onChange: function (time) {
      const d = this.value.format('YYYY-MM-DD')
      if (time.length === 0) {
        this.time = this.default
      } else {
        const t = moment(d + ' ' + time)
        this.$emit('input', t)
      }
    }
  },
  computed: {
    time: function () {
      return this.value.format('HH:mm')
    }
  }
}
</script>
